var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9AA4AF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 3l-4 4H7v8l-4 4V3h16z",
    transform: "translate(-2164.000000, -731.000000) translate(2164.000000, 731.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5l-4 4H9v8l-4 4V5h16z",
    opacity: 0.2,
    transform: "translate(-2164.000000, -731.000000) translate(2164.000000, 731.000000) translate(13.000000, 13.000000) rotate(-180.000000) translate(-13.000000, -13.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14V14H10z",
    opacity: 0.2,
    transform: "translate(-2164.000000, -731.000000) translate(2164.000000, 731.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.c04b15b767c4a9d7a037c6b60d324cf0.svg";
export { ForwardRef as ReactComponent };